import { withFieldConfigLayoutTabs } from "../components/withFieldConfigLayoutTabs.js";
import "react";
import { Checkbox, FormLayout, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Checkbox/Config.tsx
var CheckboxFieldConfig = withFieldConfigLayoutTabs(({ config, layoutType, setMultipleOptionsKeys, setOptionsKey }) => {
	if (layoutType === "Display") return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [/* @__PURE__ */ jsx(Text, {
			onChangeValue: (value) => setOptionsKey("displayCheckedLabel", value),
			label: "Checked Label",
			value: config.options.displayCheckedLabel
		}), /* @__PURE__ */ jsx(Text, {
			hint: "optional",
			onChangeValue: (value) => setOptionsKey("displayUncheckedLabel", value),
			label: "Un-Checked Label",
			value: config.options.displayUncheckedLabel,
			subText: "This label will show when the field is not checked"
		})]
	}) });
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => {
					const optionKeysList = [["formLabel", value]];
					if (config.options.displayCheckedLabel === config.options.formLabel) optionKeysList.push(["displayCheckedLabel", value]);
					if (config.options.displayUncheckedLabel === config.options.formLabel) optionKeysList.push(["displayUncheckedLabel", value]);
					setMultipleOptionsKeys(optionKeysList);
				},
				label: "Label",
				value: config.options.formLabel
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.required,
				label: "Required",
				onChangeValue: (active) => setOptionsKey("required", active),
				subText: "Make this a required field"
			})
		]
	}) });
});
//#endregion
export { CheckboxFieldConfig };

//# sourceMappingURL=Config.js.map